const Bancontact = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="24"
      fill="none"
      viewBox="0 0 38 24"
      {...props}
    >
      <g clipPath="url(#clip0_5250_96446)">
        <path
          fill="#fff"
          stroke="#EDEDED"
          d="M4 .5h30A3.5 3.5 0 0137.5 4v16a3.5 3.5 0 01-3.5 3.5H4A3.5 3.5 0 01.5 20V4A3.5 3.5 0 014 .5z"
        ></path>
        <path
          fill="#fff"
          d="M4.703 3.077h28.594c.139 0 .276.023.405.068.128.045.244.11.343.194a.9.9 0 01.229.29c.053.107.08.223.08.34V20.03a.829.829 0 01-.31.631c-.21.172-.475.265-.747.262H4.703a1.23 1.23 0 01-.405-.068 1.09 1.09 0 01-.343-.194.9.9 0 01-.229-.29.773.773 0 01-.08-.34V3.97c0-.118.027-.234.08-.342a.899.899 0 01.23-.29c.098-.082.214-.148.342-.193a1.23 1.23 0 01.405-.068z"
        ></path>
        <path
          fill="#1E3764"
          d="M6.38 18.562v-3.077h1.125c.818 0 1.344.259 1.344.795 0 .304-.167.515-.401.638.338.132.536.387.536.734 0 .62-.536.91-1.37.91H6.38zm.724-1.798h.537c.328 0 .468-.136.468-.387 0-.268-.255-.356-.6-.356h-.405v.743zm0 1.262h.448c.438 0 .693-.093.693-.383 0-.286-.22-.404-.63-.404h-.51v.787h-.001zm3.284.589c-.713 0-1.073-.295-1.073-.69 0-.436.422-.69 1.047-.695.156.002.31.014.464.035v-.105c0-.269-.183-.396-.531-.396a2.128 2.128 0 00-.688.105l-.13-.474c.291-.09.595-.134.9-.132.767 0 1.147.343 1.147.936v1.222c-.214.093-.615.194-1.136.194zm.438-.497v-.47a2.06 2.06 0 00-.37-.036c-.24 0-.427.08-.427.286 0 .185.156.281.432.281a.947.947 0 00.365-.061zm1.204.444v-2.106c.38-.128.777-.193 1.177-.193.76 0 1.198.316 1.198.9v1.399h-.72v-1.354c0-.303-.166-.444-.483-.444a1.265 1.265 0 00-.46.079v1.719h-.712zm4.886-2.167l-.135.479a1.833 1.833 0 00-.588-.11c-.422 0-.652.25-.652.664 0 .453.24.685.688.685.2-.004.397-.043.578-.114l.115.488c-.24.09-.494.133-.75.128-.865 0-1.365-.453-1.365-1.17 0-.712.495-1.182 1.323-1.182.27-.001.538.043.787.132h-.001zm1.553 2.22c-.802 0-1.302-.47-1.302-1.178 0-.704.5-1.174 1.302-1.174.807 0 1.297.47 1.297 1.173 0 .708-.49 1.179-1.297 1.179zm0-.502c.37 0 .563-.259.563-.677 0-.413-.193-.672-.563-.672-.364 0-.568.26-.568.672 0 .418.204.677.568.677zm1.713.449v-2.106c.38-.128.777-.193 1.177-.193.76 0 1.198.316 1.198.9v1.399h-.72v-1.354c0-.303-.165-.444-.483-.444a1.267 1.267 0 00-.46.079v1.719h-.712zm3.996.053c-.62 0-.938-.286-.938-.866v-.95h-.354v-.484h.355v-.488l.718-.03v.518h.578v.484h-.578v.94c0 .256.125.374.36.374.093 0 .185-.008.276-.026l.036.488c-.15.028-.3.041-.453.04zm1.814 0c-.713 0-1.073-.295-1.073-.69 0-.436.422-.69 1.047-.695.155.002.31.014.464.035v-.105c0-.269-.183-.396-.532-.396a2.128 2.128 0 00-.687.105l-.13-.474c.291-.09.595-.134.9-.132.766 0 1.146.343 1.146.936v1.222c-.213.093-.614.194-1.135.194zm.438-.497v-.47a2.06 2.06 0 00-.37-.036c-.24 0-.427.08-.427.286 0 .185.156.281.432.281a.947.947 0 00.365-.061zm3.157-1.723l-.136.479a1.833 1.833 0 00-.588-.11c-.422 0-.651.25-.651.664 0 .453.24.685.687.685.2-.004.397-.043.578-.114l.115.488c-.24.09-.494.133-.75.128-.865 0-1.365-.453-1.365-1.17 0-.712.495-1.182 1.323-1.182.27-.001.538.043.787.132zm1.58 2.22c-.62 0-.938-.286-.938-.866v-.95h-.354v-.484h.354v-.488l.72-.03v.518h.577v.484h-.578v.94c0 .256.125.374.36.374.092 0 .185-.008.276-.026l.036.488c-.15.028-.3.041-.453.04z"
        ></path>
        <path
          fill="url(#paint0_linear_5250_96446)"
          d="M11.394 13.946c3.803 0 5.705-2.14 7.606-4.28H6.38v4.28h5.014z"
        ></path>
        <path
          fill="url(#paint1_linear_5250_96446)"
          d="M26.607 5.385c-3.804 0-5.705 2.14-7.607 4.28h12.62v-4.28h-5.013z"
        ></path>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_5250_96446"
          x1="8.933"
          x2="17.734"
          y1="12.003"
          y2="8.13"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#005AB9"></stop>
          <stop offset="1" stopColor="#1E3764"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_5250_96446"
          x1="19.764"
          x2="29.171"
          y1="10.037"
          y2="6.235"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBA900"></stop>
          <stop offset="1" stopColor="#FFD800"></stop>
        </linearGradient>
        <clipPath id="clip0_5250_96446">
          <path fill="#fff" d="M0 0H38V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
}

export default Bancontact
